import React, { Component } from "react";
import Core from "Core";
import { observer, inject } from "mobx-react";
import { Modal } from "react-bootstrap";

class ModelFooterButtons extends Component {
  onCloseClick(e) {
    const { model, handler } = this.props;
    if (model) {
      if (model.isNew) {
        model.store.remove(model);
      } else {
        model.store.fetchId(model.Id);
      }

      model.store.lastError = null;
    }

    if (handler) {
      handler.close();
    }
  }

  onDeleteClick(e) {
    const { stores, model, handler } = this.props;

    if (window.confirm(stores.ui.translate.DeleteCurrentRecord)) {
      if (model) {
        model.store.deleteById(model.Id, () => {
          if (handler) {
            handler.close();
          }
        });
      }
    }
  }

  onSaveClick(e) {
    const { model, handler } = this.props;
    if (model) {
      model.store.storeModel(model, () => {
        if (handler) {
          handler.close();
        }
      });
    }
  }

  render() {
    const { model } = this.props;

    let deleteButton = null;
    if (model && !model.isNew) {
      deleteButton = (
        <Core.Components.Buttons.Delete
          className="pull-left"
          onClick={this.onDeleteClick.bind(this)}
        />
      );
    }

    return (
      <Modal.Footer>
        <Core.Components.Buttons.Cancel
          onClick={this.onCloseClick.bind(this)}
        />
        <Core.Components.Buttons.Save onClick={this.onSaveClick.bind(this)} />
        {deleteButton}
        {this.props.children}
      </Modal.Footer>
    );
  }
}

export default inject("stores", "handler")(observer(ModelFooterButtons));



// WEBPACK FOOTER //
// ./src/Core/Components/ModalParts/ModelFooterButtons.js